import { render, staticRenderFns } from "./update-email-dialog-and-button.vue?vue&type=template&id=31c400b2"
import script from "./update-email-dialog-and-button.vue?vue&type=script&lang=js"
export * from "./update-email-dialog-and-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports